import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { SITE_URL, BRAND, LANGUAGE, LANGUAGE_CODES, localePath, localeUrl } from '../config/region';
import ParticleBackground from './ParticleBackground';
import SeoHead from './SeoHead';
import posts from './blogPosts';
import { t } from '../i18n';
import './LegalPage.css';

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  const canonicalUrl = localeUrl(`/blog/${post.slug}`);
  const blogPostJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.seoTitle,
    description: post.seoDescription,
    datePublished: post.datePublished,
    dateModified: post.dateModified,
    /* Declares the language of this particular URL, which is the whole point of the prefix */
    inLanguage: LANGUAGE_CODES[LANGUAGE],
    author: { '@type': 'Organization', name: BRAND, url: SITE_URL },
    publisher: { '@type': 'Organization', name: BRAND, logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo512.png` } },
    mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
    url: canonicalUrl,
    image: `${SITE_URL}/logo512.png`,
  };
  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: BRAND, item: localeUrl('/') },
      { '@type': 'ListItem', position: 2, name: t('Блог'), item: localeUrl('/blog') },
      { '@type': 'ListItem', position: 3, name: post.seoTitle, item: canonicalUrl },
    ],
  };

  return (
    <div className="lp-wrap">
      <SeoHead
        title={post.seoTitle}
        description={post.seoDescription}
        imageAlt={post.seoTitle}
        type="article"
        jsonLd={blogPostJsonLd}
      >
        <meta property="article:published_time" content={post.datePublished} />
        <meta property="article:modified_time" content={post.dateModified} />
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      </SeoHead>
      <ParticleBackground />
      <div className="lp-app">
        <div className="lp-header">
          <a href={localePath('/blog')} className="lp-back">
            <ChevronLeft size={14} /> {t('Блог')}
          </a>
          <h1 className="lp-title">{post.title}</h1>
        </div>
        <div className="lp-body">
          {post.content}
        </div>
      </div>
    </div>
  );
};

export default BlogPostPage;
